import { Suspense, FC } from 'react';
import { Redirect, BrowserRouter, HashRouter, Switch, Route } from 'react-router-dom';

import CustomLoader from 'shared/components/CustomLoader';
import { routes } from './routes';
import { IRouterProps } from './types';
import NotFound from '../views/NotFound';

const HashBoot: FC = () => {
  const hash = typeof window !== 'undefined' ? window.location.hash : '';
  if (hash && hash.startsWith('#/')) {
    const target = hash.slice(1);
    return <Redirect to={target} />;
  }
  return <Redirect to="/checking/result/sms" />;
};

const Router: FC<IRouterProps> = ({ LayoutPage }) => {
  const forceHash = process.env.REACT_APP_FORCE_HASH_ROUTER === '1';
  const RouterBase: any = forceHash ? HashRouter : BrowserRouter;

  return (
    <RouterBase>
      <Switch>
        {routes.map(
          ({ path, exact = false, component: Component, defaultModule, ...rest }) => (
            <Route exact={exact} key={path} path={path}>
              <LayoutPage>
                <Suspense fallback={<CustomLoader />}>
                  <Component path={path} defaultModule={defaultModule} {...rest} />
                </Suspense>
              </LayoutPage>
            </Route>
          ),
        )}
        {forceHash ? (
          <Route path="/" exact>
            <Redirect to="/checking/result/sms" />
          </Route>
        ) : (
          <Route path="/" exact>
            <HashBoot />
          </Route>
        )}
        <Route>
          <NotFound text="Such a page does not exist" />
        </Route>
      </Switch>
    </RouterBase>
  );
};

export default Router;
